import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/views/AppHome'
import Login from '@/components/autenticate/login'
import NotFound from '@/components/NotFound'
import Obrigado from '@/components/Obrigado'

export var constantRouterMap = [{
  path: '/login',
  name: 'login',
  component: Login
},
{ path: '*', component: NotFound }]

const ops = [
  {
    op: 1,
    value: {
      path: '/obrigado',
      name: 'obrigado',
      component: Obrigado
    }
  }
]

Vue.use(Router)

var router = new Router({
  routes: constantRouterMap
})

export function setRoutes (drawer, redirect) {
  var baseRoute = {
    path: '/',
    name: 'home',
    component: Home,
    redirect: `/${redirect}`,
    children: []
  }

  let mapOps, route
  drawer.forEach(element => {
    mapOps = ops.map(function (e) {
      return e.op
    })
    route = ops[mapOps.indexOf(element.op)].value
    baseRoute.children.push(route)
  })

  const newRouter = new Router({
    routes: constantRouterMap
  })
  router.matcher = newRouter.matcher
  router.addRoutes([baseRoute])
}

export default router



// WEBPACK FOOTER //
// ./src/router/index.js